import { motion, SVGMotionProps } from 'motion/react';
import { useId, useState } from 'react';

interface Props extends SVGMotionProps<SVGPathElement> {
  generateMotionProps: (params: {
    pathLength: number;
  }) => SVGMotionProps<SVGPathElement>;
}

const MotionPath: React.FC<Props> = ({ generateMotionProps, ...pathProps }) => {
  const id = useId();
  const [pathLength, setPathLength] = useState<number>(0);

  return (
    <motion.path
      key={`${id}--${pathLength}`}
      ref={(node) => {
        if (node) {
          const length = node.getTotalLength();

          if (length !== pathLength) {
            setPathLength(length);
          }
        }
      }}
      {...pathProps}
      {...generateMotionProps({ pathLength })}
    />
  );
};

export default MotionPath;
